/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: dashboard-livewidget
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
	'root': true
});
